export default {
  invoice_no: 'Invoice No.',
  click_to_upload_image_for_your_logo: 'Click to upload your logoo',
  edit_form_welcome_description: 'Welcome to our website!',
  page_no: 'Page ID',
  page_link: 'Page Link',
  page_qr: 'Page QR',
  scan_open_payment_page: 'Scan to open the payment page',
  create_new_link: 'Create New Link',
  create_new_page: 'Create New Page',
  transaction_amount: 'Transaction Amount',
  total_transaction_amount: 'Total Transaction Amount',
  total_quantity: 'Total Quantity'
}
